import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  email: '',
  password: '',
  phone: '',
  firstName: '',
  lastName: '',
  avatar: '',
  company: '',
  accessToken: '',
};

export const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    addSignUpData: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearForm: () => {
      return initialState;
    }
  }
});

export const { addSignUpData, clearForm } =
  formSlice.actions;

export default formSlice.reducer;
